import { useQuery } from '@tanstack/react-query';
import { getUserCases, UserService } from '../api/reportsApi';
import { msalInstance } from '@utils';
import { statusMapping } from '../constants';

interface UseUserCasesParams {
  page: number;
  pageSize: number;
  sort: string;
  selectedStatuses: string[];
  availableStatuses: string[];
  selectedCategories: string[];
  availableCategories: string[];
  userServices: UserService[];
}

export const useUserCases = (params: UseUserCasesParams) => {
  const {
    page,
    pageSize,
    sort,
    selectedStatuses,
    availableStatuses,
    selectedCategories,
    availableCategories,
    userServices,
  } = params;

  const statusFilter =
    selectedStatuses.length > 0 &&
    selectedStatuses.length < availableStatuses.length
      ? selectedStatuses.map((s) => statusMapping[s] || s).join(',')
      : undefined;

  const serviceFilter =
    selectedCategories.length > 0 &&
    selectedCategories.length < availableCategories.length
      ? userServices
          .filter((s) => selectedCategories.includes(s.name))
          .map((s) => s.public_id)
          .filter(Boolean)
          .join(',')
      : undefined;

  const sortParts = sort.split('_');
  const sortOrder = sortParts.pop()!;
  const sortBy = sortParts.join('_');

  return useQuery({
    queryKey: [
      'userCases',
      page,
      pageSize,
      sortBy,
      sortOrder,
      statusFilter,
      serviceFilter,
    ],
    queryFn: () =>
      getUserCases({
        page,
        page_size: pageSize,
        ...(statusFilter && { status: statusFilter }),
        ...(serviceFilter && { service: serviceFilter }),
        sort_by: sortBy,
        sort_order: sortOrder,
      }),
    enabled: msalInstance.getAllAccounts().length > 0,
    staleTime: 30 * 1000,
  });
};
